import { rag_v2 } from "@/utils/axios-v2";

export type CreateConfidentialSessionPayload = {
  title?: string;
  project_id?: string;
};

export type ConfidentialSessionResponse = {
  id: string;
  expires_at: string;
};

type ConfidentialSessionErrorPayload = {
  detail?: string | { message?: string };
  message?: string;
  error?: { message?: string };
};

export const getConfidentialSessionErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!error || typeof error !== "object") return fallback;

  const maybeAxiosError = error as {
    response?: { data?: ConfidentialSessionErrorPayload };
    message?: string;
  };
  const data = maybeAxiosError.response?.data;
  const detail = data?.detail;

  if (typeof detail === "string" && detail.trim()) return detail;
  if (
    detail &&
    typeof detail === "object" &&
    typeof detail.message === "string" &&
    detail.message.trim()
  ) {
    return detail.message;
  }

  return (
    data?.error?.message || data?.message || maybeAxiosError.message || fallback
  );
};

export const createConfidentialSession = async (
  payload: CreateConfidentialSessionPayload,
): Promise<ConfidentialSessionResponse> => {
  const response = await rag_v2.post<ConfidentialSessionResponse>(
    "/confidential/sessions",
    payload,
  );
  return response.data;
};

export const closeConfidentialSession = async (
  sessionId: string,
): Promise<void> => {
  await rag_v2.post(
    `/confidential/sessions/${encodeURIComponent(sessionId)}/close`,
  );
};
